// Serviço de Push Notifications (100% gratuito)
export const pushNotificationService = {
  // Solicitar permissão para notificações
  async requestPermission(): Promise<boolean> {
    try {
      if (!('Notification' in window)) {
        console.log('❌ Este navegador não suporta notificações');
        return false;
      }

      if (Notification.permission === 'granted') {
        return true;
      }

      if (Notification.permission === 'denied') {
        console.log('❌ Notificações bloqueadas pelo usuário');
        return false;
      }

      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (error) {
      console.error('❌ Erro ao solicitar permissão:', error);
      return false;
    }
  },

  // Enviar notificação push
  async sendNotification(title: string, options: NotificationOptions = {}): Promise<boolean> {
    try {
      const hasPermission = await this.requestPermission();
      if (!hasPermission) {
        return false;
      }

      const notification = new Notification(title, {
        icon: '/images/LOGO.png',
        badge: '/images/LOGO.png',
        ...options
      });

      // Fechar notificação após 5 segundos
      setTimeout(() => {
        notification.close();
      }, 5000);

      console.log('✅ Notificação push enviada:', title);
      return true;
    } catch (error) {
      console.error('❌ Erro ao enviar notificação push:', error);
      return false;
    }
  },

  // Enviar notificação de novo contrato
  async sendNewContractNotification(contract: any): Promise<boolean> {
    try {
      const nomeContratante = contract.contratante || 'Não informado';
      const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
      const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';

      const title = '🎉 Novo Contrato - PlayKids';
      const body = `${nomeContratante} - ${nomeAniversariante} - ${dataFesta}`;

      return await this.sendNotification(title, {
        body,
        tag: 'new-contract',
        requireInteraction: true,
        actions: [
          {
            action: 'view',
            title: 'Ver Detalhes'
          },
          {
            action: 'close',
            title: 'Fechar'
          }
        ]
      });
    } catch (error) {
      console.error('❌ Erro ao enviar notificação de contrato:', error);
      return false;
    }
  },

  // Verificar se notificações são suportadas
  isSupported(): boolean {
    return 'Notification' in window;
  },

  // Verificar permissão atual
  getPermission(): NotificationPermission {
    return Notification.permission;
  }
};
